/**
 * Copy provided value to clipboard. \
 * Using deprecated `document.execCommand` if there is no `navigator.clipboard` or `window.isSecureContext === false`
 * @param valueToCopy
 * @returns
 */
export function copyToClipboard(value: any): Promise<any> {
  // Navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(value.toString()).then(() => value.toString());
  }

  return new Promise((resolve, reject) => {
    // Use the 'out of viewport hidden text area' trick
    const textArea = document.createElement('textarea');
    textArea.value = value;

    // Move textarea out of the viewport so it's not visible
    textArea.style.position = 'absolute';
    textArea.style.left = '-999999px';

    document.body.prepend(textArea);
    textArea.select();

    try {
      document.execCommand('copy');
      resolve(value.toString());
    } catch (error) {
      console.error(error);
      reject(error);
    } finally {
      textArea.remove();
    }
  });
}
